import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook, Youtube } from "lucide-react";
import { absUrl } from "../../lib/api";

export default function Footer({ site }) {
  const s = site || {};
  return (
    <footer className="bg-navy-900 text-ivory mt-24 border-t border-gold/20" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            {s.logo_url && <img src={absUrl(s.logo_url)} className="w-12 h-12 rounded-full border border-gold/50" alt="logo" />}
            <div>
              <div className="serif text-2xl">Shree Balaji</div>
              <div className="text-gold tracking-royal text-[10px] uppercase">Caterers · Vadodara</div>
            </div>
          </div>
          <p className="text-ivory/70 text-sm leading-relaxed">
            Royal Indian hospitality, plated with precision. Curated by <span className="text-gold">{s.founder_name || "Akash Sharma"}</span>.
          </p>
          <div className="flex gap-3 mt-5">
            {s.socials?.instagram && <a href={s.socials.instagram} className="w-9 h-9 rounded-full border border-gold/30 flex items-center justify-center text-gold hover:bg-gold hover:text-navy-900 transition" data-testid="social-instagram"><Instagram size={16} /></a>}
            {s.socials?.facebook && <a href={s.socials.facebook} className="w-9 h-9 rounded-full border border-gold/30 flex items-center justify-center text-gold hover:bg-gold hover:text-navy-900 transition" data-testid="social-facebook"><Facebook size={16} /></a>}
            {s.socials?.youtube && <a href={s.socials.youtube} className="w-9 h-9 rounded-full border border-gold/30 flex items-center justify-center text-gold hover:bg-gold hover:text-navy-900 transition" data-testid="social-youtube"><Youtube size={16} /></a>}
          </div>
        </div>

        <div>
          <div className="label-eyebrow mb-4">Explore</div>
          <ul className="space-y-2 text-sm text-ivory/80">
            <li><Link to="/packages" className="hover:text-gold">Packages</Link></li>
            <li><Link to="/menus" className="hover:text-gold">Menus</Link></li>
            <li><Link to="/services" className="hover:text-gold">Services</Link></li>
            <li><Link to="/special-setups" className="hover:text-gold">Special Setups</Link></li>
            <li><Link to="/gallery" className="hover:text-gold">Gallery</Link></li>
          </ul>
        </div>

        <div>
          <div className="label-eyebrow mb-4">Company</div>
          <ul className="space-y-2 text-sm text-ivory/80">
            <li><Link to="/about" className="hover:text-gold">About</Link></li>
            <li><Link to="/testimonials" className="hover:text-gold">Testimonials</Link></li>
            <li><Link to="/blog" className="hover:text-gold">Blog</Link></li>
            <li><Link to="/faq" className="hover:text-gold">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-gold">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="label-eyebrow mb-4">Reach Us</div>
          <ul className="space-y-3 text-sm text-ivory/80">
            <li className="flex gap-2 items-start"><Phone size={14} className="text-gold mt-1" /> <a href={`tel:${s.phone}`} className="hover:text-gold">{s.phone || "+91 9328797924"}</a></li>
            <li className="flex gap-2 items-start"><Mail size={14} className="text-gold mt-1" /> <a href={`mailto:${s.email}`} className="hover:text-gold">{s.email || "info@balajicaterers.com"}</a></li>
            <li className="flex gap-2 items-start"><MapPin size={14} className="text-gold mt-1" /> <span>{s.address || "Vadodara, Gujarat"}</span></li>
            {s.gst_number && <li className="text-xs text-ivory/60 tracking-wider">GSTIN: {s.gst_number}</li>}
          </ul>
        </div>
      </div>

      <div className="border-t border-gold/15">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-ivory/50">
          <span>{s.footer?.copy || `© ${new Date().getFullYear()} Shree Balaji Caterers · Crafted with reverence in Vadodara`}</span>
          <Link to="/admin/login" className="hover:text-gold tracking-wider uppercase" data-testid="footer-admin-link">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
